import React from 'react'

import Image from 'next/image'

import { Text } from 'Components/UI'

import { useResponsiveLayout } from 'Hooks'

import { WELCOME_SECTION_GALLERY_ITEMS } from './constants'
import { Card, Container, Overflow } from './styles'

function MoreThanJustGolfSectionGallery() {
  const { isDesktop } = useResponsiveLayout()

  return (
    <Container
      gap={isDesktop ? 5 : 3}
      gridTemplateColumns={isDesktop ? 'repeat(4, 1fr)' : 'repeat(2, 1fr)'}
    >
      {WELCOME_SECTION_GALLERY_ITEMS.map(item => (
        <Card height={isDesktop ? 185 : 135} key={item.id}>
          <Image alt={item.title + item.caption} fill src={item.image.src} />

          <Overflow />

          <Text bold inverse screen24={!isDesktop} screen38={isDesktop}>
            {item.title}
          </Text>

          <Text inverse medium screen18={!isDesktop} screen24={isDesktop}>
            {item.caption}
          </Text>
        </Card>
      ))}
    </Container>
  )
}

export default MoreThanJustGolfSectionGallery
